(() => {
  const page = document.querySelector("[data-sc-signs-page]");
  if (!page) return;

  const hideThemeChrome = () => {
    document.documentElement.classList.add("sc-signs-theme");
    const headerGroup = document.getElementById("header-group");
    const footerGroup = document.getElementById("footer-group");
    if (headerGroup) headerGroup.hidden = true;
    if (footerGroup) footerGroup.hidden = true;

    Array.from(document.body.children).forEach((child) => {
      if (child === page.closest(".shopify-section")) return;
      if (child.matches("header, footer")) child.hidden = true;
    });
  };

  hideThemeChrome();
  document.addEventListener("DOMContentLoaded", hideThemeChrome);
  window.addEventListener("load", hideThemeChrome, { once: true });

  const slides = Array.from(page.querySelectorAll(".sc-signs-gallery-slide"));
  const dots = Array.from(page.querySelectorAll("[data-gallery-index]"));
  const setGallerySlide = (index) => {
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === index);
    });
    dots.forEach((dot) => {
      const active = Number(dot.dataset.galleryIndex) === index;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", active ? "true" : "false");
    });
  };

  dots.forEach((dot) => {
    dot.addEventListener("click", () => setGallerySlide(Number(dot.dataset.galleryIndex)));
  });

  page.querySelectorAll(".sc-signs-product-form").forEach((form) => {
    const packageInputs = Array.from(form.querySelectorAll(".sc-signs-package input"));
    const purchaseInputs = Array.from(form.querySelectorAll('input[name="purchase_option"]'));
    const sellingPlanInput = form.querySelector("[data-signs-selling-plan]");

    const syncSelection = () => {
      const checkedPackage = packageInputs.find((input) => input.checked);
      const checkedCard = checkedPackage?.closest(".sc-signs-package");
      const subscription = purchaseInputs.find((input) => input.checked)?.value === "subscription";

      packageInputs.forEach((input) => {
        input.closest(".sc-signs-package")?.classList.toggle("is-selected", input.checked);
      });

      if (sellingPlanInput) {
        const planId = checkedCard?.dataset.sellingPlanId || "";
        sellingPlanInput.value = subscription ? planId : "";
        sellingPlanInput.disabled = !subscription || !planId;
      }
    };

    form.addEventListener("change", syncSelection);
    syncSelection();
  });

  const track = page.querySelector("[data-review-track]");
  const reviewButtons = Array.from(page.querySelectorAll("[data-review-direction]"));
  let reviewIndex = 0;

  const visibleReviewCount = () => {
    if (window.matchMedia("(max-width: 767px)").matches) return 1;
    return 3;
  };

  const updateReviewTrack = () => {
    if (!track) return;
    const cards = Array.from(track.children);
    const maxIndex = Math.max(0, cards.length - visibleReviewCount());
    reviewIndex = Math.min(maxIndex, Math.max(0, reviewIndex));
    const firstCard = cards[0];
    if (!firstCard) return;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const offset = reviewIndex * (firstCard.getBoundingClientRect().width + gap);
    track.style.transform = `translateX(${-offset}px)`;
    reviewButtons.forEach((button) => {
      const direction = Number(button.dataset.reviewDirection);
      button.disabled = direction < 0 ? reviewIndex === 0 : reviewIndex === maxIndex;
    });
  };

  reviewButtons.forEach((button) => {
    button.addEventListener("click", () => {
      reviewIndex += Number(button.dataset.reviewDirection);
      updateReviewTrack();
    });
  });

  updateReviewTrack();
  window.addEventListener("resize", updateReviewTrack);

  page.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (event) => {
      const target = page.querySelector(anchor.getAttribute("href"));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start",
      });
    });
  });
})();
